import { Output } from '@angular/core';

export class PostDataSource {
  private parent: any;
  private service: any;
  private resultKey: string;
  private querystrings: any;
  private init: boolean;
  
  @Output() errorMessage;

  public rowCount: any;
  private beforeRequest;
  private successCallback;

  constructor(params: any) {
    this.parent = params.parent;
    this.service = params.service;
    this.resultKey = params.resultKey;
    this.querystrings = params.querystrings;
    this.init = false;
    this.beforeRequest = params.beforeRequest;
    this.successCallback = params.successCallback;
  }

  
  getRows(params) {
    this.parent.working = true;
    
    if (this.querystrings) {
      for (var i in this.querystrings) {
		params[i] = this.querystrings[i];
      }
    }

    if (this.beforeRequest) {
      this.beforeRequest(params)
    }
    console.log('[DataSource::getRows] params of getRows', params);
    this.service
      .post(params)
      .then(outputJson => {
        console.log('[DataSource::getRows::then] Response', outputJson);
		this.init = true;
        this.parent.working = false;
        const rowsThisPage = outputJson[this.resultKey];
        const lastRow = outputJson.total;
        // call the success callback
        params.successCallback(rowsThisPage, lastRow);
        if (this.successCallback) {
          this.successCallback(rowsThisPage, lastRow)
        }
      })
      .catch(error => {
		this.parent.working = false;
        console.log(this.parent.commonService.getErrorMessage(error));
        // this.parent.dialogsService.info('エラー', this.parent.commonService.getErrorMessage(error));
        this.errorMessage = this.parent.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/classes/dataSource/postDataSource.ts